import axios from "../../utils/axios";
import {
  REMOVE_WAREHOUSE,
  SET_INVITED_ADMIN,
  SET_WAREHOUSE,
  SET_WAREHOUSE_ADMINS,
  SET_WAREHOUSES_LIST
} from "./actionTypes";
import {setErrors} from "./error";

// Get warehouses
export const getWarehouses = () => dispatch => {
  axios
      .get('warehouse/?show_all')
      .then(response => dispatch(setWarehousesList(response.data)))
      .catch(console.log);
};

const setWarehousesList = warehouses => ({
  type: SET_WAREHOUSES_LIST,
  payload: warehouses
});

// Delete warehouse
export const deleteWarehouse = id => dispatch => {
  axios
      .delete(`warehouse/${id}/`)
      .then(response => dispatch(removeWarehouse(id)))
      .catch(console.log);
};

const removeWarehouse = id => ({
  type: REMOVE_WAREHOUSE,
  payload: id
});

export const getWarehouseAdmins = () => dispatch => {
  axios
      .get('company-warehouse-admin/?show_all')
      .then(response => dispatch(setWarehouseAdmins(response.data)))
      .catch(console.log);
};

const setWarehouseAdmins = admins => ({
  type: SET_WAREHOUSE_ADMINS,
  payload: admins.results
});

export const addWarehouse = (data, history) => dispatch => {
  axios
      .post('create-warehouse/', data)
      .then(() => history.push('/warehouses'))
      .catch(error => {
        if (error.response.status === 400) {
          dispatch(setErrors({name: error.response.data.detail[0]}));
        }
      });
};

export const getWarehouse = (id, history) => dispatch => {
  axios
      .get(`warehouse/${id}/`)
      .then(response => dispatch(setWarehouse(response.data)))
      .catch(error => {
        if (error.response.status === 404) {
          history.push('/404');
        }
      });
};

export const setWarehouse = data => ({
  type: SET_WAREHOUSE,
  payload: data
});

export const setInvitedAdmin = admin => ({
  type: SET_INVITED_ADMIN,
  payload: admin
});

export const deleteDock = id => () => {
  axios
      .delete(`dock/${id}/`)
      .then()
      .catch(console.log);
};

export const updateWarehouse = (body, history) => dispatch => {
  axios
      .post('update-warehouse/', body)
      .then(() => history.push('/warehouses'))
      .catch(error => {
        if (error.response.status === 400) {
          dispatch(setErrors({name: error.response.data.detail[0]}));
        }
      });
};


// WEBPACK FOOTER //
// ./src/store/actions/warehouse.js